'use client';

import React, { useState, useEffect, useRef } from 'react';
import styles from './AppFooter.module.css';
import { useLocale } from '../context/DynamicLocaleProvider';
import { getVersion } from '../utils/version';
import BrandSwitchModal from './BrandSwitchModal';

export default function AppFooter({ inline = false }: { inline?: boolean }) {
  const { t } = useLocale();
  const [clickCount, setClickCount] = useState(0);
  const [showModal, setShowModal] = useState(false);
  const clickTimeoutRef = useRef<NodeJS.Timeout | null>(null);
  const lastClickTimeRef = useRef<number>(0);

  const handleCopyrightClick = () => {
    const now = Date.now();
    
    // Reset if more than 2 seconds passed since last click
    const newCount = now - lastClickTimeRef.current > 2000 ? 1 : clickCount + 1;
    
    lastClickTimeRef.current = now;

    // Clear existing timeout
    if (clickTimeoutRef.current) {
      clearTimeout(clickTimeoutRef.current);
    }

    // Open modal after 10 clicks
    if (newCount >= 10) {
      setShowModal(true);
      setClickCount(0);
    } else {
      setClickCount(newCount);
      
      // Reset count after 2 seconds of no clicks
      clickTimeoutRef.current = setTimeout(() => {
        setClickCount(0);
      }, 2000);
    }
  };

  useEffect(() => {
    return () => {
      if (clickTimeoutRef.current) {
        clearTimeout(clickTimeoutRef.current);
      }
    };
  }, []);

  return (
    <>
      <footer className={`${styles.footer} ${inline ? styles.inline : ''}`}>
        <div className={styles.container}>

          {/* Copyright */}
          <p className={styles.copy}>
            <span onClick={handleCopyrightClick}>&copy;</span> {new Date().getFullYear()} THESCON GmbH <span className={styles.version}>v{getVersion()}</span>
          </p>

        <nav className={styles.nav}>
          <div className={styles.links}>
            {/* Privacy */}
            <a
              href="https://www.thescon.com/datenschutzerklarung"
              className={styles.link}
              target="_blank"
              rel="noopener noreferrer"
            >
              {t('footer_privacy')}
            </a>

            {/* Imprint */}
            <a
              href="https://www.thescon.com/impressum"
              className={styles.link}
              target="_blank"
              rel="noopener noreferrer"
            >
              {t('footer_imprint')}
            </a>

          </div>
        </nav>
      </div>
    </footer>

    {/* Brand Switch Modal */}
    <BrandSwitchModal
      isOpen={showModal}
      onClose={() => setShowModal(false)}
    />
    </>
  );
}